import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
    getComponentsByProject,
    createComponent,
    findComponentByValue,
    getComponentsForTestCase,
    assignComponentToTestCase,
    removeComponentFromTestCase,
} from '../services/component.service';

import { componentKeys } from '../constants/componentKeys';

export const useComponentsByProject = (projectId) => {
    return useQuery({
        queryKey: [componentKeys.projectComponents, projectId],
        queryFn: () => getComponentsByProject(projectId),
        enabled: !!projectId,
    });
};

export const useCreateComponent = ({ onSuccess, onError } = {}) => {
    return useMutation({
        mutationFn: createComponent,
        onSuccess: (data) => onSuccess?.(data),
        onError: (error) => onError?.(error),
    });
};

export const useFindComponentByValue = (projectId, value) => {
    return useQuery({
        queryKey: [componentKeys.searchComponent, projectId, value],
        queryFn: () => findComponentByValue(projectId, value),
        enabled: !!projectId && !!value?.trim(),
    });
};


export const useTestCaseComponents = (testCaseId) => {
    return useQuery({
        queryKey: [componentKeys.testCaseComponents, testCaseId],
        queryFn: () => getComponentsForTestCase(testCaseId),
        enabled: !!testCaseId,
    });
};

export const useAssignComponentToTestCase = (testCaseId, { onSuccess, onError } = {}) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (componentId) => assignComponentToTestCase(testCaseId, componentId),
        onSuccess: (data) => {
            queryClient.invalidateQueries([componentKeys.testCaseComponenrs, testCaseId]);
            onSuccess?.(data);
        },
        onError: (error) => onError?.(error),
    });
};

export const useUnassignComponentFromTestCase = (testCaseId, { onSuccess, onError } = {}) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (componentId) => removeComponentFromTestCase(testCaseId, componentId),
        onSuccess: () => {
            queryClient.invalidateQueries([componentKeys.testCaseComponents, testCaseId]);
            onSuccess?.();
        },
        onError: (error) => onError?.(error),
    });
};
